<ng-container *ngIf="!iconClass">
	<div class="avatar-container">
		<img
			[attr.alt]="'accessibility.profilepicture.single' | translate : { name: userName }"
			class="avatar superuser"
			[src]="buildUrl()"
		/>
		<div class="user-badge" *ngIf="sudoMode">
			<i class="ico ico-superuser-key"></i>
		</div>
	</div>
</ng-container>

<ng-container *ngIf="iconClass">
	<div class="avatar custom-icon" [ngClass]="{ 'table-icon': !isList, 'list-icon': isList }">
		<i class="ico {{ iconClass }}"></i>
	</div>
</ng-container>
